import React from 'react';
import {useNumberFormat} from "../../../hooks";

export default function CartDiscount({discount, optionsPagesTotal} ) {
  const {
    discountIsExists,
    discountText,
    discountPrice
  } = discount;

  const {format} = useNumberFormat();
  var discountPages  = optionsPagesTotal.discount;

  return (
      <>
          {discountIsExists && (
              <div className="app-cart-discount">
                  <div className="app-cart-line">
                      <div className="app-cart-line-left">
                          <span className="app-cart-text-parameter">{discountText}</span>
                      </div>
                      <div className="app-cart-line-right">
                          <span className="app-cart-text-value">${discountPrice}</span>
                      </div>
                  </div>
              </div>
          )}

          {discountPages >0 && (
              <div className="app-cart-discount">
                <div className="app-cart-line">
                  <div className="app-cart-line-left">
                    <span className="app-cart-text-parameter">Discount</span>
                  </div>
                  <div className="app-cart-line-right">
                    <span className="app-cart-text-value">${format(discountPages)}</span>
                  </div>
                </div>
              </div>
          )}
      </>
  )
}
